<div class="flex items-center justify-center p-4 gap-2 custom-paginator">
  <mat-label for="select-element" class="text-sm font-light mx-1">{{
    'PAGINATION.page_size' | translate
  }}</mat-label>
  <mat-form-field appearance="outline" class="page-size-selector p-0 mr-8">
    <mat-select
      [value]="pageSize"
      (selectionChange)="onPageSizeChange($event.value)"
      [attr.id]="'select-element'"
      [attr.name]="'select-element'"
      [attr.aria-label]="'PAGINATION.page_size' | translate"
    >
      @for (option of pageSizeOptions; track option) {
        <mat-option [value]="option" role="option">{{ option }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (totalPages) {
    <button
      mat-mini-fab
      (click)="goToFirstPage()"
      [disabled]="isFirstPage"
      [attr.aria-label]="'PAGINATION.first_page' | translate"
      [matTooltip]="'PAGINATION.first_page' | translate"
      class="btn-paginator-primary"
    >
      <mat-icon class="material-icons-outlined">fast_rewind</mat-icon>
    </button>
  }

  <button
    mat-mini-fab
    (click)="goToPreviousPage()"
    [disabled]="isFirstPage"
    [attr.aria-label]="'PAGINATION.prev_page' | translate"
    [matTooltip]="'PAGINATION.prev_page' | translate"
    class="btn-paginator-primary"
  >
    <mat-icon>navigate_before</mat-icon>
  </button>

  <span class="text-sm font-light mx-1">
    {{ 'PAGINATION.page' | translate }}
    @if (!totalPages) {
      {{ pageIndex + 1 }}
    }
  </span>

  @if (totalPages) {
    <mat-form-field
      appearance="outline"
      class="w-16.25 text-center m-0 p-0 [&_.mat-mdc-form-field-wrapper]:m-0! [&_.mat-mdc-form-field-wrapper]:pb-0! [&_.mat-mdc-form-field-flex]:items-center! [&_.mat-mdc-form-field-flex]:h-10!"
    >
      <input
        #pageInput
        matInput
        type="number"
        [formControl]="pageFormControl"
        (blur)="onInputGoToPage(pageFormControl.value)"
        (keyup.enter)="onInputGoToPage(pageFormControl.value)"
        min="1"
        [max]="totalPages || 1"
        [attr.aria-label]="'PAGINATION.current_page' | translate"
        [matTooltip]="'PAGINATION.current_page' | translate"
        class="text-center text-base h-full p-0"
      />
    </mat-form-field>

    <span class="text-sm font-light mx-1"
      >{{ 'PAGINATION.of_page' | translate }} {{ totalPages || 0 }}</span
    >
  }

  <button
    mat-mini-fab
    (click)="goToNextPage()"
    [disabled]="isLastPage || (!totalPages && !arrowForward)"
    [attr.aria-label]="'PAGINATION.next_page' | translate"
    [matTooltip]="'PAGINATION.next_page' | translate"
    class="btn-paginator-primary"
  >
    <mat-icon>navigate_next</mat-icon>
  </button>

  @if (totalPages) {
    <button
      mat-mini-fab
      (click)="goToLastPage()"
      [disabled]="isLastPage"
      [attr.aria-label]="'PAGINATION.last_page' | translate"
      [matTooltip]="'PAGINATION.last_page' | translate"
      class="btn-paginator-primary"
    >
      <mat-icon class="material-icons-outlined">fast_forward</mat-icon>
    </button>
  }
</div>
